module.exports = __webpack_public_path__ + "img/地点.286458fe.png";